import React, { useCallback, useEffect, useState } from 'react';

import { Search } from '~/ui/assets/icons';
import { Container, Input } from './SearchBar.styled';

interface ISearchBarProps {
  placeholder?: string;
  onChange?: (value: string) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  initialValue?: string;
}

export function SearchBar({ placeholder = 'Buscar', onChange, onKeyPress, initialValue }: ISearchBarProps) {
  const [value, setValue] = useState(initialValue || '');

  const handleOnChange = useCallback((e) => {
    setValue(e.target.value);
    onChange(e.target.value);
  }, []);

  useEffect(() => {
    if (!initialValue) {
      setValue('');
    }
  }, [initialValue]);

  return (
    <Container>
      <Search className="action-icon" width={20} height={20} color="#727272" data-testid="search-bar-icon" />
      <Input placeholder={placeholder} onChange={handleOnChange} value={value} onKeyPress={onKeyPress} autoFocus />
    </Container>
  );
}
